import React from "react";
import * as PropTypes from "prop-types";
import {Menu} from "antd";
import {prop, sortBy} from 'ramda';
import ButtonDropdown from "./ButtonDropdown";

const sortByTitle = sortBy(prop("title"));
const { SubMenu } = Menu;

function getMap(availableMembers, onClick) {
  return sortByTitle(availableMembers).map(m => (
      <Menu.Item key={m.name} onClick={() => onClick(m)}>
        {m.title}
      </Menu.Item>
  ));
}

const getMapExt = (availableMembers, onClick, index =0) => {
  const groups = [...new Set(availableMembers.map(v => v.tree[index] || ''))];

  return groups.sort().map(m => {
    const group = availableMembers.filter(v => (v.tree[index] == m))

    if (group.length) {
      if (group.length == 1) {
        return(<Menu.Item key={group[0].name} onClick={() => onClick(group[0])}>
          {group[0].title.replaceAll(/\_/g, ' ')}
        </Menu.Item>)}
      else {
        return(
            <SubMenu  title={m.replaceAll(/\_/g, ' ')}>
              {getMapExt(group, onClick, index + 1)}
            </SubMenu >)
      }
    } else {
      return 'Пусто'
    }
  })
}

const memberMenu = (onClick, availableMembers) => {
  if (availableMembers.length)
    availableMembers.forEach( v => {v.tree = v.title.split(' ') || []})
  return (  <Menu mode="vertical">
    {availableMembers.length ? getMapExt(availableMembers, onClick) : (
      <Menu.Item disabled>Пусто</Menu.Item>
    )}
  </Menu>
)};

const MemberDropdown = ({ onClick, availableMembers, ...buttonProps }) => (
  <ButtonDropdown
    overlay={memberMenu(onClick, availableMembers)}
    {...buttonProps}
  />
);

MemberDropdown.propTypes = {
  onClick: PropTypes.func.isRequired,
  availableMembers: PropTypes.array.isRequired
};
export default MemberDropdown;
